import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { ConfirmDismissDialogComponent } from 'app/modules/shared/components/confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { DataService, HTTPService, HelperService } from 'app/services';

import { find, findIndex } from 'lodash';
import { DeleteCategoryDialogComponent } from '../delete-category-dialog/delete-category-dialog.component';
import { AutoCompleteComponent } from 'app/modules/shared/components/auto-complete/auto-complete.component';
import { messages } from 'app/constants';

@Component({
  selector: 'app-sales-code-add-dialog',
  templateUrl: './sales-code-add-dialog.component.html',
  styleUrls: ['./sales-code-add-dialog.component.scss'],
})
export class SalesCodeAddDialogComponent implements OnInit {
  @ViewChild('salesGroupdDropdown') salesGroupdDropdown: AutoCompleteComponent;

  itemTypes = [
    { name: 'Parts', type: 'part', disabled: false, tooltip: 'Sales code classification for part has already been created.' },
    { name: 'Labor', type: 'labor', disabled: false, tooltip: 'Sales code classification for labor has already been created.' },
    { name: 'Tires', type: 'tire', disabled: false, tooltip: 'Sales code classification for tire has already been created.' },
    { name: 'Tire Storage', type: 'tireStorage', disabled: false, tooltip: 'Sales code classification for tire storage has already been created.' },
    { name: 'Fees', type: 'hazmatFee', disabled: false, tooltip: 'Sales code classification for fees has already been created.' },
  ];
  categoriesSuggestions: any[] = [];
  subCategoriesSuggestions: any[] = [];
  subSubCategoriesSuggestions: any[] = [];
  individualSearch: any = {};
  salesCodes: any[] = [];
  salesCode: any = {
    title: '',
    shortName: '',
    salesGroup: {
      _id: '',
      name: '',
    },
  };
  defaultSalesCode: any;
  defaultItemsData: any;
  salesGroups: any = [];
  salesGroupsResults: any = [];
  loaders = {
    isSaving: false,
  };
  itemSearchQuery: string = '';
  isEditMode: boolean = false;
  hideRadioBtn: boolean = false;
  isRoyaltyReportEnabled: boolean = false;
  errors: any = {};
  newSalesGroup: any = {
    name: '',
    groupCode: '',
    m2GroupName: '',
    m2GroupCode: '',
    type: 'sales_group',
    _id: '',
  };
  loader = {
    category: false,
    subCategory: false,
    subSubCategory: false,
    isSavingCode: false,
  };
  isCreateNew: boolean = false;
  isEditModeCode: boolean = false;
  isMidasRoyaltyReportsEnable: boolean = false;
  isReqRefresh: boolean = false;
  categorySearchOptions = {
    query: '',
    page: 1,
  };
  isSearchingCategories: boolean = false;
  isPaginating: boolean = false;
  canEditClassifications: boolean = false;
  classificationPrivilegeMsg: string = messages.salesCodePrivilegeMsg;

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dialogService: DialogService,
    private dConfig: DynamicDialogConfig,
    private httpService: HTTPService,
    private helperService: HelperService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private el: ElementRef,
  ) { }

  ngOnInit(): void {
    this.isRoyaltyReportEnabled = this.dataService.isRoyaltyReportEnabled;
    this.isMidasRoyaltyReportsEnable = this.dataService.isMidasRoyaltyReportsEnable;
    this.canEditClassifications = this.dataService.canEditSalesCode;
    if (this.dConfig.data?._id) {
      this.isEditMode = true;
      this.getSalesCode(this.dConfig.data);
    } else {
      this.handleAddSalesCode();
    }

    this.getSalesGroup('');
  }

  ngAfterViewInit() {
    this.toggleCustomStyles(true);
  }

  getSalesCode({ shortName }) {
    this.httpService.getSalesCode(shortName).then(
      (res: any) => {
        if (res.length) {
          this.setSelectedSalesCode(res);
          this.disabledItemTypes();
        }
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      },
    );
  }

  async getSalesGroup(query: string = '') {
    try {
      this.salesGroupsResults = await this.httpService.getTags('sales_group', query);
    } catch (err) {
      console.log(err);
      this.helperService.showToaster('error', err);
    }
  }

  setSelectedSalesCode(salesCodes: any[] = []) {
    const [salesCode] = salesCodes;
    this.salesCode = {
      title: salesCode.title,
      shortName: salesCode.shortName,
      salesGroup: salesCode.salesGroup,
    };

    if (salesCodes.length) this.salesCodes = [];

    salesCodes.forEach((salesCode: any) => {
      const _salesCode: any = {
        _id: salesCode._id,
        itemType: salesCode.itemType,
        salesCodeCategories: salesCode.salesCodeCategories,
        individualSearch: {},
        itemSearchQuery: '',
      };
      this.salesCodes.push(_salesCode);
      this.getAllCategories(_salesCode, '');
      this.searchCategories('', _salesCode);
    });
    this.defaultSalesCode = { ...this.salesCode };
    this.defaultItemsData = this.helperService.deepCopy(this.salesCodes);
  }

  async searchCategories(query: string = '', item: any, page: number = 0) {
    try {
      let limit = 80;
      this.categorySearchOptions = { query, page };
      this.isSearchingCategories = !page;
      this.isPaginating = !!page;
      const [{ records = [] }]: any = await this.httpService.getCategoryList({
        limit,
        sortField: 'category.categoryName',
        skip: this.categorySearchOptions.page * limit,
        isDetailedResult: true,
        searchTerm: this.categorySearchOptions.query,
        itemType: item.itemType,
      });
      records.forEach((record: any) => {
        record.isActive = !this.categoryChecked(record, item);
        if (record?.salesCode?.title) {
          record.tooltipMsg = `Classification is already assigned to Sales Code ${record?.salesCode?.title}`;
        } else {
          record.tooltipMsg = `Classification is already assigned to this Sales Code`;
        }
      });

      if (!this.categorySearchOptions.page) {
        item.categoriesResults = [...records];
      } else {
        item.categoriesResults = [...item.categoriesResults, ...records];
      }
      this.isSearchingCategories = false;
      this.isPaginating = false;
    } catch (err) {
      console.log(err);
      this.helperService.showToaster('error', err);
      this.isSearchingCategories = false;
      this.isPaginating = false;
    }
  }

  getItemTitle(item: any, isFormated = false) {
    return [
      !isFormated ? item.category : item.category?.categoryName,
      !isFormated ? item.subCategory : item.subCategory?.subCategoryName,
      !isFormated ? item.subSubCategory : item.subSubCategory?.subSubCategoryName,
    ]
      .filter((str) => str)
      .join(' > ');
  }

  handleChange(type, event, item?) {
    if (type === 'category') item.itemSearchQuery = event;
    else this.salesCode[type] = event;
  }

  handleItemTypeChange(itemType: string, item: any, index: number) {
    if (itemType !== this.salesCodes[index].itemType && item.salesCodeCategories?.length) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '60%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          isCustomizedConfirmationBox: true,
          isHTML: true,
          headerIcon: 'fas fa-exclamation',
          title: `Are you sure you want to change the Item Type?`,
          message: `<div>
                        <p class="m-0 font-12 font-400 mb-2">
                          If you choose to proceed, all Item Classifications added against the current Item Type will be deleted.
                        </p>
                      </div>`,
          button: {
            success: { title: 'Confirm' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess }) => {
        if (isSuccess) {
          this.salesCodes[index].itemType = itemType;
          this.salesCodes[index].itemSearchQuery = '';
          this.salesCodes[index].individualSearch = {};
          this.salesCodes[index].salesCodeCategories = [];
          this.disabledItemTypes();
          this.getAllCategories(item, '');
          this.searchCategories('', item);
        }

        onClose.unsubscribe();
      });
    } else {
      this.salesCodes[index].itemType = itemType;
      this.disabledItemTypes();
      this.getAllCategories(item, '');
      this.searchCategories('', item);
    }
  }

  disabledItemTypes() {
    const selectedItemTypes = this.salesCodes.filter(({ isDeleted }) => !isDeleted).map(({ itemType }) => itemType);
    this.itemTypes.forEach((itemType) => {
      if (selectedItemTypes.includes(itemType.type)) {
        itemType.disabled = true;
      } else {
        itemType.disabled = false;
      }
    });
  }

  checkItemTypeSelected(type, i) {
    if (i > 0) {
      return this.salesCodes.find((element, index) => index < i && type === element.itemType) ? true : false;
    }
    return false;
  }

  formatCategory(item) {
    const data: any = { _id: item._id };

    if (item.category && item.categoryId) {
      data.category = {
        categoryId: item.categoryId,
        categoryName: item.category,
      };
    }
    if (item.subCategory && item.subCategoryId) {
      data.subCategory = {
        subCategoryId: item.subCategoryId,
        subCategoryName: item.subCategory,
      };
    }
    if (item.subSubCategory && item.subSubCategoryId) {
      data.subSubCategory = {
        subSubCategoryId: item.subSubCategoryId,
        subSubCategoryName: item.subSubCategory,
      };
    }

    return data;
  }

  onClearSuggestion(type: string, item: any = {}) {
    if (type === 'category') {
      this.searchCategories('', item);
    } else if (type === 'salesGroup') {
      this.getSalesGroup();
    } else if (type === 'individualCategory') {
      this.getAllCategories(item, '');
    } else if (type === 'subCategory') {
      this.getSubCategories(item, '');
    } else if (type === 'subSubCategory') {
      this.getSubSubCategories(item, '');
    }
  }

  searchItem(name: string, query: string, salesCode: any) {
    if (name === 'category') {
      this.getAllCategories(salesCode, query);
    } else if (name === 'subCategory') {
      this.getSubCategories(salesCode, query);
    } else if (name === 'subSubCategory') {
      this.getSubSubCategories(salesCode, query);
    }
  }

  onCategorySelect(event, item: any) {
    item.itemSearchQuery = '';
    const index = findIndex(item.salesCodeCategories, { _id: event._id });
    if (index !== -1 || event.salesCode?.salesCodeId) return;
    const formatedData = this.formatCategory(event);
    if (index === -1) item.salesCodeCategories.push(formatedData);

    this.checkAddButtonEditable(event, item);
  }

  categoryChecked(category: any, item: any) {
    if (findIndex(item.salesCodeCategories, { _id: category._id }) !== -1) return true;
    if (this.isEditMode) {
      if (category?.salesCode?.salesCodeId && this.defaultSalesCode.title !== category?.salesCode?.title) return true;
    } else {
      if (category?.salesCode?.salesCodeId) return true;
    }

    return false;
  }

  removeCategoryItem(index: number, item: any) {
    if (item.salesCodeCategories.length) {
      const category = this.helperService.deepCopy(item.salesCodeCategories[index]);
      item.salesCodeCategories.splice(index, 1);
      this.checkAddButtonEditable(category, item);
    }
  }

  handleAddSalesCode() {
    const itemType = find(this.itemTypes, { disabled: false });
    const emptySalesCodeIndex = findIndex(this.salesCodes || [], { itemType: '' });

    if (emptySalesCodeIndex !== -1) {
      this.salesCodes[emptySalesCodeIndex].itemType = itemType.type;
    } else if (itemType) {
      this.salesCodes.push({
        salesCodeCategories: [],
        itemType: itemType.type,
        individualSearch: {},
        itemSearchQuery: '',
      });
    }

    this.getAllCategories(this.salesCodes[this.salesCodes.length - 1], '');
    this.searchCategories('', this.salesCodes[this.salesCodes.length - 1]);
    this.disabledItemTypes();
  }

  handleDeleteSalesCode(index: number) {
    if (this.salesCodes?.length && this.salesCodes[index]?.salesCodeCategories?.length) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '60%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          isCustomizedConfirmationBox: true,
          isHTML: true,
          headerIcon: 'fas fa-exclamation',
          title: `Are you sure you want to delete this Item Type?`,
          message: `<div>
                        <p class="m-0 font-12 font-400 mb-2">
                          If you choose to proceed, this Sales Code will not be applied on all items that fall under this Item Type and are associated with the Item Classifications added here.
                        </p>
                      </div>`,
          button: {
            success: { title: 'Confirm' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess }) => {
        if (isSuccess && this.salesCodes.length) {
          if (this.salesCodes[index]._id) {
            this.salesCodes[index].isDeleted = true;
          } else {
            this.salesCodes.splice(index, 1);
          }
          this.disabledItemTypes();
        }
        onClose.unsubscribe();
      });
    } else {
      if (this.salesCodes.length) {
        if (this.salesCodes[index]._id) {
          this.salesCodes[index].isDeleted = true;
        } else {
          this.salesCodes.splice(index, 1);
        }
        this.disabledItemTypes();
      }
    }
  }

  checkAddButtonEditable(existingItem: any, item: any) {
    item.isAddBtnDisabled = this.categoryChecked(existingItem, item);
    if (item.isAddBtnDisabled) {
      if (existingItem?.salesCode?.title) {
        item.btnTooltip = `Classification is already assigned to Sales Code ${existingItem?.salesCode?.title}`;
      } else {
        item.btnTooltip = `Classification is already assigned to this Sales code`;
      }
    }
  }

  categoryDropdownSelect(type: string, event: any, item: any) {
    if (type === 'subSubCategory' && this.categoryChecked(event, item)) return;

    if (type === 'category' && event.categoryId) {
      item.individualSearch.category = event;
      delete item.individualSearch?.subCategory;
      delete item.individualSearch?.subSubCategory;
      this.getSubCategories(item);
    }

    if (type === 'subCategory' && event.subCategoryId) {
      item.individualSearch.subCategory = event;
      delete item.individualSearch?.subSubCategory;
      this.getSubSubCategories(item);
    }

    if (type === 'subSubCategory' && event.subSubCategoryId) {
      item.individualSearch.subSubCategory = event;
    }

    item.individualSearch._id = event._id;
    this.checkAddButtonEditable(event, item);
  }

  addIndividualCategories(item: any) {
    const selectedItem: any = {};
    let salesCode: any = {};

    if (item.individualSearch?.category?.categoryId) {
      selectedItem._id = item.individualSearch._id;
      selectedItem.category = {
        categoryName: item.individualSearch.category.categoryName,
        categoryId: item.individualSearch.category.categoryId,
      };
      salesCode = item.individualSearch.category.salesCode;

      if (item.individualSearch?.subCategory?.subCategoryId) {
        selectedItem.subCategory = {
          subCategoryName: item.individualSearch.subCategory.subCategoryName,
          subCategoryId: item.individualSearch.subCategory.subCategoryId,
        };
        salesCode = item.individualSearch.subCategory.salesCode;

        if (item.individualSearch?.subSubCategory?.subSubCategoryId) {
          selectedItem.subSubCategory = {
            subSubCategoryName: item.individualSearch.subSubCategory.subSubCategoryName,
            subSubCategoryId: item.individualSearch.subSubCategory.subSubCategoryId,
          };
          salesCode = item.individualSearch.subSubCategory.salesCode;
        }
      }
    }

    if (salesCode?.salesCodeId && this.isEditMode) {
      if (this.defaultSalesCode.title !== salesCode.title || findIndex(item.salesCodeCategories || [], { _id: selectedItem._id }) !== -1) {
        this.helperService.showToaster('error', 'Classification is already assigned to this or any other sales code for the selected item type');
        return;
      }
    }

    item.salesCodeCategories.push(selectedItem);
    item.individualSearch = {};
  }

  async getAllCategories(salesCode: any, search: string = '') {
    try {
      this.loader.category = true;
      const query: any = { itemType: salesCode.itemType, searchTerm: search };
      const results: any = await this.httpService.getPricingCategories(query);

      salesCode.categoriesSuggestions = results.categories;
    } catch (err) {
      console.log(err);
      this.helperService.showToaster('error', err);
    } finally {
      this.loader.category = false;
    }
  }

  async getSubCategories(data: any, searchQuery = '') {
    data.subCategoriesSuggestions = [];
    this.loader.subCategory = true;
    try {
      const {
        itemType,
        individualSearch: {
          category: { categoryId },
        },
      } = data;
      const result: any = await this.httpService.getPricingSubCategories(categoryId, itemType, searchQuery);

      if (result?.subCategories?.length >= 0) {
        data.subCategoriesSuggestions = result.subCategories;
      }
    } catch (err) {
      console.log(err);
      this.helperService.showToaster('error', err);
    } finally {
      this.loader.subCategory = false;
    }
  }

  async getSubSubCategories(data: any, search = '') {
    data.subSubCategoriesSuggestions = [];

    try {
      this.loader.subSubCategory = true;
      const {
        itemType,
        individualSearch: {
          category: { categoryId },
          subCategory: { subCategoryId },
        },
      } = data;
      const results: any = await this.httpService.getPricingSubSubCategories(categoryId, subCategoryId, itemType, search);

      if (results?.subSubCategories?.length >= 0) {
        results.subSubCategories.forEach((result: any) => {
          result.isActive = !this.categoryChecked(result, data);
          if (!result.isActive) {
            if (result?.salesCode?.title) {
              result.subSubtooltipMsg = `Classification is already assigned to Sales Code ${result?.salesCode?.title}`;
            } else {
              result.subSubtooltipMsg = `Classification is already assigned to this Sales Code`;
            }
          }
        });
        data.subSubCategoriesSuggestions = results.subSubCategories;
      }
    } catch (err) {
      console.log(err);
      this.helperService.showToaster('error', err);
    } finally {
      this.loader.subSubCategory = false;
    }
  }

  isValidate() {
    if (!this.salesCode.title) return false;
    if (!this.salesCode.shortName) return false;
    if (!this.salesCode?.salesGroup?._id) return false;

    // const salesCodes = this.salesCodes.filter(({ isDeleted }) => !isDeleted);
    // if (salesCodes.length) {
    //   const item = salesCodes?.find(({ salesCodeCategories }) => !salesCodeCategories.length);
    //   if (item) return false;
    //   else return true;
    // } else return false;
    return true;
  }

  handleClose(isSuccess: boolean = true, data: any = {}) {
    this.dynamicDialogRef.close({ isSuccess, data });
  }

  // Sales group functions
  onSalesGroupSelect({ _id, name, groupCode }) {
    this.salesCode.salesGroup = { _id, name, code: groupCode };
  }

  async onSalesGroupSearch(query: string) {
    try {
      await this.getSalesGroup(query);
    } catch (err) {
      console.log(err);
      this.helperService.showToaster('error', err);
    }
  }

  onFocus(type) {
    this.errors[type] = '';
  }

  validationSalesGroupItems() {
    let isValid = true;

    if (!this.newSalesGroup.name) {
      this.errors.name = 'Group name required';
      isValid = false;
    }
    if (!this.newSalesGroup.groupCode) {
      this.errors.groupCode = 'Group code required';
      isValid = false;
    }

    if (this.isMidasRoyaltyReportsEnable) {
      if (!this.newSalesGroup.m2GroupCode) {
        this.errors.m2GroupCode = 'Group code required';
        isValid = false;
      }
      if (!this.newSalesGroup.m2GroupName) {
        this.errors.m2GroupName = 'Group name required';
        isValid = false;
      }
    }
    return isValid;
  }
  async onSalesGroupCreate(close) {
    if (!this.validationSalesGroupItems()) {
      return;
    }
    if (this.isEditModeCode) {
      this.onSalesGroupUpdate(this.newSalesGroup);
      return;
    }
    try {
      this.loader.isSavingCode = true;
      const salesGroup = await this.httpService.createTag(this.newSalesGroup);
      this.loader.isSavingCode = false;
      this.getSalesGroup();

      if (salesGroup?._id) {
        this.onSalesGroupSelect(salesGroup);
      }

      this.isCreateNew = false;

      if (this.salesGroupdDropdown) {
        this.salesGroupdDropdown.handleClose();
      }
      if (close) close();
    } catch (err) {
      console.log(err);
      this.loader.isSavingCode = false;

      this.helperService.showToaster('error', err);
    }
  }

  async onSalesGroupUpdate(event) {
    console.log(event);
    const index = findIndex(this.salesGroupsResults, { _id: event._id });
    if (index === -1) return;

    try {
      await this.httpService.updateTag(this.newSalesGroup);
      this.salesGroupsResults[index].name = event.name;
      this.salesGroupsResults[index].groupCode = event.groupCode;

      if (this.salesCode.salesGroup?._id === event._id) {
        this.salesCode.salesGroup.name = event.name;
        this.salesCode.salesGroup.code = event.groupCode;
      }
      this.isCreateNew = false;
      // this.getSalesGroup();
      this.dataService.sendData(this.dataService.typePassData('sales-code-list', {}));
    } catch (err) {
      console.log(err);
      this.helperService.showToaster('error', err);
    }
  }

  async handleDeleteSalesGroup(salesGroup: any) {
    try {
      salesGroup.isLoading = true;
      const data = await this.httpService.deleteSalesGroup(salesGroup._id);

      if (!data.salesCodeCount) {
        const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
          width: '60%',
          styleClass: 'small-heading-dialog',
          showHeader: false,
          data: {
            styleClassHeading: 'font-14',
            isCustomizedConfirmationBox: true,
            isHTML: true,
            headerIcon: 'fas fa-exclamation',
            title: `Are you sure you want to delete this Sales Group?`,
            message: `<div>
                          <p class="m-0 font-12 font-400 mb-2">
                            If you choose to proceed, this Sales Group will not be applied on all items that fall under this Sales code and are associated with the Item Classifications added here.
                          </p>
                        </div>`,
            button: {
              success: { title: 'Confirm' },
              cancel: { title: 'Cancel' },
            },
          },
        });

        const onClose = ref.onClose.subscribe(({ isSuccess }) => {
          if (isSuccess) {
            this.onSalesGroupDelete(salesGroup);
            this.dataService.sendData(this.dataService.typePassData('sales-code-list', {}));
          }
          onClose.unsubscribe();
        });
      } else {
        const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
          width: '1200px',
          styleClass: 'add-dialog overflow-initial delete-category-dialog',
          showHeader: false,
          data: {
            dialogType: 'salesGroup',
            currentSalesGroup: salesGroup,
            salesGroups: data.salesGroups,
            salesCodeCount: data.salesCodeCount,
          },
        });

        const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
          console.log(this.helperService.deepCopy(data));
          if (isSuccess && data?.replacedSalesGroup?._id) {
            const salesGroup = {
              _id: data.replacedSalesGroup._id,
              name: data.replacedSalesGroup.name,
              groupCode: data.replacedSalesGroup.code,
            };
            // const obj = find(this.salesGroupsResults, { _id: data.replacedSalesGroup._id });
            // if (obj) {
            this.onSalesGroupSelect(salesGroup);
            this.dataService.sendData(this.dataService.typePassData('sales-code-list', {}));
            // }
            this.isReqRefresh = isSuccess;
          }
          onClose.unsubscribe();
        });
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      salesGroup.isLoading = false;
    }
  }

  async onSalesGroupDelete(salesGroup: any) {
    const index = findIndex(this.salesGroupsResults, { _id: salesGroup._id });

    if (index !== -1) {
      try {
        await this.httpService.deleteTag(salesGroup._id);
        if (this.salesCode?.salesGroup?._id === salesGroup._id) {
          this.salesCode.salesGroup = {};
        }
        this.salesGroupsResults.splice(index, 1);
        this.getSalesGroup();
      } catch (err) {
        console.log(err);
        this.helperService.showToaster('error', err);
      }
    }
  }

  async saveSalesCode() {
    if (this.loaders.isSaving) return;
    this.loaders.isSaving = true;

    try {
      const payload = this.setPayload();

      if (this.isEditMode) {
        this.handleEditConfirmation(payload);
      } else {
        await this.httpService.saveSalesCode(payload);
        this.handleClose(true);
        this.helperService.showToaster('success', 'Sales code created successfully');
      }
    } catch (err) {
      console.log(err);
      this.helperService.showToaster('error', err);
    } finally {
      this.loaders.isSaving = false;
    }
  }

  setPayload() {
    const payload = { ...this.salesCode };

    payload.details = this.helperService.deepCopy(this.salesCodes);
    payload.details?.forEach((detail: any) => {
      delete detail.categories;
      delete detail.categoriesResults;
      delete detail.categoriesSuggestions;
      delete detail.subCategoriesSuggestions;
      delete detail.subSubCategoriesSuggestions;
      delete detail.individualSearch;
      delete detail.itemSearchQuery;
    });

    return payload;
  }

  handleEditConfirmation(payload) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '60%',
      styleClass: 'add-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        isCustomizedConfirmationBox: true,
        isHTML: true,
        headerIcon: 'fas fa-exclamation',
        title: `Are you sure you want to update the Sales Code?`,
        message: `<div>
                      <p class="m-0 font-14 font-400 mb-2">
                        Changes made to this Sales Code will have an affect on the following:
                      </p>
                      <p class="m-0 font-16">
                       <ul class="font-400">
                        <li>If you've removed an item classification, items with that classification will no longer be associated with this Sales Code after this update</li>
                        <li>If you've added an item classification, items with that classification will be associated with this Sales Code after this update</li>
                        <li>If you've updated the Sales Code Name, Sales Code Shortcut or Sales Group, this change will be reflected across the application after this update</li>
                        </ul>
                      </p>
                    </div>`,
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(async ({ isSuccess }) => {
      if (isSuccess) {
        this.httpService.updateSalesCode(payload).then(
          (res) => {
            this.handleClose(true);
            this.helperService.showToaster('success', 'Sales code updated successfully');
          },
          (error) => {
            this.helperService.showToaster('error', error);
          },
        );
      }
      onClose.unsubscribe();
    });
  }

  handleChangeSalesCode(type, data) {
    this.newSalesGroup[type] = data;
  }

  onEditItem(item) {
    this.toggleCustomStyles(false);
    this.isCreateNew = true;
    this.isEditModeCode = true;
    this.newSalesGroup = {
      ...item,
    };
  }

  isCreate(data) {
    this.toggleCustomStyles(!data);
    if (data === true) {
      Object.keys(this.newSalesGroup).forEach((key) => {
        this.newSalesGroup[key] = '';
        this.onFocus(key)
      });

      this.newSalesGroup.type = 'sales_group';
      delete this.newSalesGroup?._id;
    }
    this.isEditModeCode = false;
    this.isCreateNew = data;
  }

  toggleCustomStyles(shouldAdd: boolean) {
    const targetElement = this.el.nativeElement.querySelector('.autocomplete .autocomplete-wrapper .autocomplete-list-wrapper .custom-create-field');

    if (targetElement) {
      if (shouldAdd) {
        this.renderer.addClass(targetElement, 'custom-style-class');
      } else {
        this.renderer.removeClass(targetElement, 'custom-style-class');
      }
    }
  }
}
